export const tableHeaders = {
    customerName : 'Customer Name',
    customerCode : 'Customer Code',
    pincode : 'Pincode',
    createdOn : 'Created On',
    createdBy : 'Created By',
    modifiedOn : 'Modified On',
    modifiedBy : 'Modified By',
    actions : 'Edit/Delete'
}

export const billingPartyBranchConst = {
    fields : {
        branch_name : {
            title : "Branch Name",
            placeholder : "Enter Branch Name"
        },
        state : {
            title : "State",
            placeholder : "Select State"
        },
        city : {
            title : "City",
            placeholder : "Select City"
        },
        pincode : {
            title : "Pincode",
            placeholder : "Enter Pincode"
        },
        pan_number : {
            title : "Pan Number",
            placeholder : "Enter Pan Number"
        },
        contact_person : {
            title : "Contact Person Name",
            placeholder : "Enter Contact Person Name"
        },
        mobile : {
            title : "Mobile No",
            placeholder : "Enter Mobile No"
        },
        landline : {
            title :"LandLine No",
            placeholder: "Enter LandLine No"
        },
        address : {
            title :"Address",
            placeholder : "Enter Address"
        },
        is_gst_applicable : {
            title : "Is GST Applicable?"
        },
        gst_no : {
            title : "GST Number",
            placeholder : "Enter GST Number"
        },
        is_gst_exempted  :{
            title : "Is GST Exempted?"
        },
        exempted_reason : {
            title : "GST Exempted Reason",
            placeholder : "Select GST Exempted Reason"
        },
        bank_name : {
            title : "Bank Name",
            placeholder : "Enter Bank Name"
        },
        account_holder : {
            title : "Account Holder",
            placeholder : "Enter Account Holder Name"
        },
        account_no : {
            title : "Account Number",
            placeholder : "Enter Account Number"
        },
        ifsc : {
            title : "IFSC Code",
            placeholder : "Enter IFSC Code"
        }
    },
    table_title : "Branch Details",
    table_headers : {
        branch : "Branch",
        branch_code : "Branch Code",
        gst_no : "GST Number",
        address : "Address",
        pincode : "Pincode",
        edit : "Edit",
        delete : "Delete",
        more : "More Details",
    },
    gst_title : "GST Details",
    bank_title  :"Bank Details",
    detail_headers : {
        branch_name : "Branch Name",
        branch_code : "Branch Code",
        state :"State",
        city :  "City",
        pincode :  "Pincode",
        pan_number :  "Pan Number",
        contact_person : "Contact Person Name",
        mobile :  "Mobile No",
        landline :"LandLine No",
        address : "Address",
        is_gst_applicable :  "Is GST Applicable?",
        gst_no :  "GST Number",
        is_gst_exempted  : "Is GST Exempted?",
        exempted_reason :"GST Exempted Reason",
        bank_name : "Bank Name",
        account_holder : "Account Holder",
        account_no :"Account Number",
        ifsc :  "IFSC Code",
    },
}

export const buttons = {
    cancel : "Cancel",
    submit : "Submit",
    new :"New",
    ok : "Ok"
}